export default __webpack_public_path__ + "static/media/arrow-square-right.6c3ff3e6.svg";